import styled, { css } from 'styled-components';

const withDataStyles = css`
  background-color: var(--success100);
  border: 1px solid var(--success700);

  svg {
    path {
      fill: var(--success900);
    }
  }
`;

const noDataStyles = css`
  background-color: var(--grey100);
  border: 1px solid var(--grey300);

  svg {
    path {
      fill: var(--grey700);
    }
  }
`;

export const Container = styled.div`
  ${({ noData }) => (noData ? noDataStyles : withDataStyles)}
  padding: 8px;
  padding-left: 12px;
  display: flex;
  border-radius: 4px;
  align-items: flex-start;

  .icon {
    margin-right: 8px;
  }
`;

export const Content = styled.div`
  p {
    margin: 0;
    margin-top: 6px;
  }
`;
